// Golf 5 (Arabisch): toestemming van een ouder voor een kind onder 16 (eigen login, foto) en de
// pagina met de privacyverklaring. Zelfde vorm als golf5App.nl.ts; de toestemmingsteksten tellen
// mee in CHILD_CONSENT_TEXT_HASHES.
export const appChildConsentAr = {
    version: '2026-09-26.1',
    title: 'موافقة من أجل {name}',
    intro: '{name} عمره أقل من 16 سنة. قبل حساب دخول خاص أو صورة نطلب أولًا موافقة أحد الوالدين.',
    notNeeded: '{name} عمره 16 سنة أو أكثر ويقرر بنفسه بشأن حساب دخول خاص وصورة.',
    login: {
        title: 'حساب دخول خاص',
        text: 'بحساب دخول خاص يستطيع {name} الدخول إلى التطبيق بنفسه من هاتف أو حاسوب. يرى {name} عندها تقويم العائلة ومهامها ونقاطها ورسائلها، لكنه لا يرى أبدًا الموافقات أو عناوين البريد الإلكتروني أو المعلومات الصحية. تحتفظ AMUMIN B.V. بمن أعطى الموافقة ومتى وأي نص قرأته. يمكنك سحب الموافقة في أي وقت: يتوقف حساب الدخول فورًا.',
        check: 'أنا أحد والدي {name} أو الوصي عليه وأوافق على حساب دخول خاص.',
    },
    photo: {
        title: 'صورة بدل الرمز',
        text: 'بالموافقة يمكنك استخدام صورة {name} بدل رمز. تظهر الصورة عندها في التطبيق وعلى اللوحة على الحائط: يراها كل من في الغرفة التي فيها الجهاز اللوحي. نحذف الموقع والبيانات الأخرى من الصورة ولا نشاركها مع أحد. تحتفظ AMUMIN B.V. بمن أعطى الموافقة ومتى وأي نص قرأته. يمكنك سحب الموافقة في أي وقت: تُحذف الصورة فورًا.',
        check: 'أنا أحد والدي {name} أو الوصي عليه وأوافق على صورة.',
    },
    ask: 'إعطاء الموافقة',
    give: 'أعطِ الموافقة',
    cancel: 'ليس الآن',
    withdraw: 'سحب',
    withdrawConfirm: 'نعم، اسحب الموافقة',
    withdrawLogin: 'هل تسحب الموافقة على حساب الدخول الخاص؟ يتوقف حساب {name} فورًا.',
    withdrawPhoto: 'هل تسحب الموافقة على الصورة؟ تُحذف صورة {name} فورًا.',
    none: 'لا توجد موافقة بعد',
    givenBy: 'موافقة من {name} بتاريخ {date}',
    givenByYou: 'موافقتك بتاريخ {date}',
    givenOn: 'موافقة بتاريخ {date}',
    hasLogin: 'لدى {name} الآن حساب دخول خاص.',
    hasPhoto: 'لدى {name} الآن صورة.',
    given: 'تم إعطاء الموافقة',
    withdrawn: 'تم سحب الموافقة',
    withdrawnLogin: 'حساب {name} لم يعد يعمل.',
    withdrawnPhoto: 'تم حذف صورة {name}.',
    checkRequired: 'ضع علامة في المربع أولًا.',
    privacyLink: 'المزيد في بيان الخصوصية',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: 'لدى {name} حساب دخول بدون موافقة: أعطِ الموافقة أو أوقف حساب الدخول.',
    disableLogin: 'إيقاف حساب الدخول',
    disableLoginAsk: 'هل توقف حساب دخول {name}؟ يتوقف الحساب فورًا.',
    disableLoginConfirm: 'نعم، أوقفه',
    loginDisabled: 'تم إيقاف حساب دخول {name}.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'لدى هؤلاء الأطفال حساب دخول بدون موافقة: أعطِ الموافقة أو أوقف حساب الدخول.',
    gateLogin: 'لدى هذا الشخص حساب دخول خاص. يحتاج الطفل دون 16 سنة أولًا إلى موافقة أحد الوالدين: احذف حساب الدخول أولًا، ثم غيّر العمر، وبعد ذلك أعطِ الموافقة.',
    gatePhoto: 'لا يمكن استخدام صورة طفل دون 16 سنة إلا بموافقة أحد الوالدين. أعطِ الموافقة أولًا أو احذف الصورة.',
};
export const appPrivacyStatementAr = {
    title: 'بيان الخصوصية',
    back: 'العودة إلى التطبيق',
    concept: 'مسودة، قيد المراجعة القانونية',
    version: 'الإصدار {version} · {date}',
    contents: 'المحتويات',
    onlyDutch: 'بيان الخصوصية غير متوفر بالعربية بعد. تجد أدناه النص الهولندي، ويمكنك اختيار الإنجليزية أيضًا.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    placeholder: 'سيُستكمل لاحقًا',
};
//# sourceMappingURL=golf5App.ar.js.map